// Re-export the singleton client so all existing imports continue to work.
// This eliminates "Multiple GoTrueClient instances" by always returning the same instance.
import { supabase } from '@/lib/supabaseClient';

export function createClient() {
  return supabase;
}
